import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgDashboard = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.60437 18.1645C8.90925 18.817 9.82475 18.8383 10.1598 18.2006L15.4717 8.09104L17.5325 12.0753C17.8097 12.6121 18.532 12.7097 18.9412 12.2671L21.7676 9.2065C22.0945 8.85324 22.0741 8.29998 21.7219 7.97131C21.3697 7.64263 20.8195 7.66311 20.4926 8.01721L18.5059 10.168L16.2495 5.80414C15.9259 5.17875 15.0365 5.17548 14.7096 5.79923L9.43588 15.8349L6.69927 9.98845C6.46856 9.4942 5.84901 9.33192 5.40716 9.64912L2.36398 11.8351C1.97349 12.1154 1.883 12.6613 2.16181 13.0547C2.4406 13.4474 2.98435 13.5383 3.37484 13.258L5.57031 11.681L8.60437 18.1645Z", fill: props.fill }));
});
export default SvgDashboard;
